<template>
  <div>

    <div class="banner">
      <div class="item" style="position:relative;">
        <!-- <img v-if="this.dataList.length > 0" :src="dataList[currentIndex].url" /> -->
        <div v-if="this.dataList.length > 0" :style=" {backgroundImage:'url('+dataList[currentIndex].url+')'}" class="homeIndexImg"></div>
      </div>

      <div class="page" v-if="this.dataList.length > 1">
        <ul>
          <div class="circle">
            <ul class="cirbox">
              <li :key="item.id" v-for="(item,index) in dataList" :class="{'active':currentIndex == index}" @click="gotoPage(index)"></li>
            </ul>
          </div>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import { getBannerList } from "@/api/common"
export default {
  name: "slider",
  components: {},
  props: {},
  data() {
    return {
      dataList: [],
      currentIndex: 0, //默认显示图片
      timer: null //定时器
    };
  },

  mounted() {
    this.runInv();
    this.getBannerListFunction(this.$store.state.page);
  },
  computed: {

    //上一张
    prevIndex() {
      if (this.currentIndex == 0) {
        return this.dataList.length - 1;
      } else {
        return this.currentIndex - 1;
      }
    },
    //下一张
    nextIndex() {
      if (this.currentIndex == this.dataList.length - 1) {
        return 0;
      } else {
        return this.currentIndex + 1;
      }
    }
  },
  methods: {
    //轮播图获取
    async getBannerListFunction(type) {
      const { code, data } = await getBannerList(type);
      if (code == 200) {
        this.dataList = data;
        let BASE_URL = this.Global;
        this.dataList.forEach(function (element) {
          element.url != null ? (element.url = `${BASE_URL}${element.url}`) : "";
        });

      }
    },
    gotoPage(index) {
      this.currentIndex = index;
    },
    //定时器 10S切换
    runInv() {
      this.timer = setInterval(() => {
        this.gotoPage(this.nextIndex);
      }, 10000);
    },
    chooseMenu(key) {
      switch (key) {
        case 1:
          this.dataList = this.dataListA;
          break;
        case 2:
          this.dataList = this.dataListB;
          break;
        case 3:
          this.dataList = [
            "http://gangmao.oss-cn-shenzhen.aliyuncs.com/wys/news.png"
          ];
          break;
        case 4:
          this.dataList = [
            "http://gangmao.oss-cn-shenzhen.aliyuncs.com/wys/wys1.png"
          ];
          break;
        case 5:
          this.dataList = [
            "http://gangmao.oss-cn-shenzhen.aliyuncs.com/wys/news.png"
          ];
          break;
        case 6:
          this.dataList = this.dataListB;
          break;
        case 7:
          this.dataList = [
            "http://gangmao.oss-cn-shenzhen.aliyuncs.com/wys/banner.jpg"
          ];
          break;
        case 8:
          this.dataList = [
            "http://gangmao.oss-cn-shenzhen.aliyuncs.com/wys/news.png"
          ];
          break;
        case 9:
          this.dataList = [
            "http://gangmao.oss-cn-shenzhen.aliyuncs.com/wys/banner.jpg"
          ];
          break;
        case 10:
          this.dataList = [
            "http://gangmao.oss-cn-shenzhen.aliyuncs.com/wys/wys.png"
          ];
          break;
        default:
          this.dataList = this.dataListA;
      }
    }
  }
};
</script>
<style scoped>
/* ul li {
  list-style: none;
  float: left;
  width: 30px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
} */
.banner {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.banner img {
  /* max-width: 88.54vw; */
  max-width: 1920px;
  display: block;
  height: 85.555vh;
  /* background-image: url(/your/image/path.jpg);
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat */
}
.homeIndexImg {
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  max-width: 88.54vw;
  height: 85.555vh;
}
.banner .page {
  position: absolute;
  z-index: 11;
  /* right: 10px;
  float: right;
  bottom: 0; */
  width: 100%;
}
/* .banner .page ul {
  float: left;
} */
.current {
  color: #ff6700;
}
/* 底部圆点 */
.circle {
  /* backgroound:red; */
  /* position: absolute; */
  z-index: 11;
  position: absolute;
  text-align: right;
  bottom: 30px;
  right: 112px;
  width: 100%;
  /* height: 14px; */
  /* background:red */
}
.circle .cirbox {
  display: inline-block;
  border-radius: 7px;
  font-size: 0; /*不加这一句，会使li在ul中向下偏移*/
}
.circle .cirbox li {
  display: inline-block;
  width: 7px;
  height: 7px;
  background: #ffffff;
  border-radius: 50%;
  cursor: pointer;
  margin: 2px;
}
.circle .cirbox .active {
  width: 20px;
  height: 7px;
  background: #ffffff;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/banner.vue